import React, { useState } from 'react';
import { useStyles } from '@webapps/styles';
import { combine } from '../../utils/styles';
import { linkpickTheme } from '@webapps/styles';
import { Info } from '@material-ui/icons';

export default function InfoTooltip({ title, description, link, position = 'right', forceVisible = false }) {
  const { classes, cx } = useStyles(styles);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  return (
    <div
      className={classes.tooltipContainer}
      onMouseEnter={() => setIsTooltipVisible(true)}
      onMouseLeave={() => setIsTooltipVisible(false)}
    >
      <Info className={classes.infoIcon} />
      {(isTooltipVisible || forceVisible) && (
        <div className={cx(classes.tooltipBox, classes[position])}>
          <div className={classes.title}>{title}</div>
          <div className={classes.description}>{description}</div>
          {link && (
            <div className={classes.linkContainer}>
              <a href={link.href} onClick={link.onClick} className={classes.link}>
                {link.text}
              </a>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const styles = () => {
  const { colors, fontSizes2, gap } = linkpickTheme.params;
  
  return {
    tooltipContainer: {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
    },
    infoIcon: {
      height: '16px',
      width: '16px',
      fill: '#a8caff',
      cursor: 'pointer',
    },
    tooltipBox: {
      position: 'absolute',
      zIndex: 101,
      ...gap.xs,
      alignItems: "flex-start",
      backgroundColor: colors.blanc,
      borderRadius: "6px",
      borderLeft: `10px solid ${colors.bleuElectrique}`, 
      boxShadow: "rgba(21, 38, 82, 0.3) 10px 10px 10px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      width: "300px",
      padding: '15px 15px 15px 25px'
    },
    right: {
        top: '50%', 
        left: 'calc(100% + 10px)', 
        transform: 'translateY(-50%)',
    },
    left: {
        top: '50%', 
        right: 'calc(100% + 10px)', 
        transform: 'translateY(-50%)',
    },
    top: {
        bottom: 'calc(100% + 10px)', 
        left: '50%', 
        transform: 'translateX(-50%)',
    },
    bottom: {
        top: 'calc(100% + 10px)', 
        left: '50%', 
        transform: 'translateX(-50%)',
    },
    title: {
      ...combine(fontSizes2.bodyMd),
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: "600",
      color: colors.bleuMarine,
      width: "100%",
    },
    description: {
      ...combine(fontSizes2.body),
      fontFamily: '"Roboto", sans-serif',
      color: colors.bleuArdoise,
      width: "100%",
    },
    linkContainer: {
      ...combine(fontSizes2.body),
      fontFamily: '"Roboto", sans-serif',
      color: colors.bleuMarine,
    },
    link: {
      color: colors.bleuMarine,
      textDecoration: "underline",
      cursor: "pointer",
      '&:hover': {
        textDecoration: "underline",
      }
    },
  }
};